import Vue from 'vue'

function mergeArray (baseValue, value) {
  for (let i = 0; i < value.length; i) {
    let val = stateMerge(baseValue[i], value[i]);
    if (val === undefined) {
      continue
    }
    if (baseValue[i]) {
      Vue.set(baseValue, i, val)
    } else {
      baseValue.push(val)
    }
  }
}

function mergeObject (baseValue, value) {
  for (let key of Object.keys(value)) {
    let val = stateMerge(baseValue[key], value[key])
    if (val === undefined) {
      // if (baseValue.hasOwnProperty(key)) {
      //   Vue.delete(baseValue, key)
      // }
      continue
    }
    Vue.set(baseValue, key, val)
  }
  return baseValue
}

export const stateMerge = (baseValue, value) => {
  if (Array.isArray(baseValue) && Array.isArray(value)) {
    mergeArray(baseValue, value)
  } else if (value && baseValue && typeof value === 'object' && typeof baseValue === 'object') {
    mergeObject(baseValue, value)
  } else {
    return (value !== undefined) ? value : baseValue
  }
}
